document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".product__accordion details");

  accordions.forEach((accordion) => {
    const summary = accordion.querySelector("summary");
    const content = accordion.querySelector(".accordion__content");

    // Sicherstellen, dass Summary + Content existieren
    if (!summary || !content) return;

    // INITIALER STATUS (für den Fall, dass "open" im DOM gesetzt ist)
    const isOpen = accordion.hasAttribute("open");
    summary.setAttribute("aria-expanded", isOpen ? "true" : "false");

    // A11Y toggle aktualisieren
    accordion.addEventListener("toggle", () => {
      const open = accordion.open;
      summary.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
});